/**
 * Configuracoes — definicao das abas do hub unificado (A3).
 *
 * Cada aba: grupo (rail), path (sub-rota), label, icone (SVG fiel ao mockup)
 * e gate de RBAC. Abas pessoais (Conta/Aparencia) nao tem gate; abas de Dados
 * e Sistema herdam os gates dos modulos que estao sendo movidos para ca.
 *
 * gate: null  -> visivel para qualquer usuario autenticado
 *       { master: true }      -> somente Master
 *       { allOf: ["a:b"] }    -> precisa de TODAS as permissoes
 *       { anyOf: ["a:b",...] }-> precisa de PELO MENOS UMA
 *       { modulosAny: [...] } -> a unidade contratou PELO MENOS UM dos modulos
 *                                (ADR-0102); combina com allOf/anyOf
 */
import React from "react";

import { MODULO_PLANILHA_LEGADO, MODULO_PROJETOS_EXECUTIVOS } from "../../config/modulos";
import { PERMS_ENTRAR_ACESSOS } from "../Acessos/permissoes";

const sv = (children) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    {children}
  </svg>
);

export const ICONS = {
  perfil: sv(<><circle cx="12" cy="8" r="4" /><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" /></>),
  seguranca: sv(<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />),
  notificacoes: sv(<><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></>),
  aparencia: sv(<><circle cx="13.5" cy="6.5" r="2.5" /><circle cx="17.5" cy="10.5" r="2.5" /><circle cx="8.5" cy="7.5" r="2.5" /><circle cx="6.5" cy="12.5" r="2.5" /><path d="M12 2a10 10 0 0 0 0 20 1.5 1.5 0 0 0 1-2.6 1.5 1.5 0 0 1 1-2.6h2a5 5 0 0 0 5-5 10 10 0 0 0-9-9.8z" /></>),
  planilhas: sv(<><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M3 15h18M9 3v18M15 3v18" /></>),
  exportacao: sv(<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />),
  importacoes: sv(<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />),
  integracoes: sv(<path d="M10 13a5 5 0 0 0 7 0l4-4a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-4 4a5 5 0 0 0 7 7l1-1" />),
  cad: sv(<><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 3v18" /></>),
  acessos: sv(<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />),
  calendario: sv(<><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>),
  unidade: sv(<><path d="M3 21h18M5 21V7l7-4 7 4v14" /><path d="M9 21v-6h6v6" /></>),
  agenda: sv(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  ia: sv(<><rect x="4" y="7" width="16" height="12" rx="3" /><path d="M12 3v4M9 12h.01M15 12h.01M9 16h6" /></>),
  dinabox: sv(<><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><path d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12" /></>),
};

export const GRUPOS = ["Conta", "Aparência", "Dados", "Sistema"];

export const TABS = [
  { grupo: "Conta", path: "perfil", label: "Perfil", icone: ICONS.perfil, gate: null,
    titulo: "Perfil", desc: "Veja e edite suas informações pessoais — nome, foto e cargo exibido na organização." },
  { grupo: "Conta", path: "seguranca", label: "Segurança & MFA", icone: ICONS.seguranca, gate: null,
    titulo: "Segurança & MFA", desc: "Altere sua senha e gerencie a autenticação em dois fatores." },
  { grupo: "Conta", path: "notificacoes", label: "Notificações", icone: ICONS.notificacoes, gate: null,
    titulo: "Notificações", desc: "Escolha o que e como você quer ser avisado." },
  { grupo: "Conta", path: "dinabox", label: "DinaBox", icone: ICONS.dinabox, gate: null,
    titulo: "DinaBox", desc: "Sua credencial pessoal do DinaBox, usada pelo Revisor de Lista de Ferragens." },
  // Guia de conexão: o passo a passo de todos os caminhos, para a pessoa conectar sozinha.
  { grupo: "Conta", path: "conectar", label: "Guia: conectar", icone: ICONS.integracoes, gate: null,
    titulo: "Guia de conexão", desc: "Passo a passo para levar a sua agenda ao celular, ao Google Agenda e à sua IA." },
  // MCP do ERP (ADR-0091): cada pessoa conecta as próprias IAs; nada de outra pessoa aparece.
  // Assinatura .ics (ADR-0092) e via dupla Google/CalDAV (ADR-0093): cada pessoa liga a própria.
  { grupo: "Conta", path: "calendario-celular", label: "Calendário no celular", icone: ICONS.calendario, gate: null,
    titulo: "Calendário no celular", desc: "Sincronize a sua agenda com o Google Agenda e o iPhone/Mac, ou assine um link só para ver." },
  { grupo: "Conta", path: "integracoes-ia", label: "Integrações de IA", icone: ICONS.ia, gate: null,
    titulo: "Integrações de IA", desc: "Conecte Claude, ChatGPT e outras IAs à sua agenda, gerencie as chaves e veja o que elas fizeram." },

  { grupo: "Aparência", path: "aparencia", label: "Tema & cores", icone: ICONS.aparencia, gate: null,
    titulo: "Tema & cores", desc: "Escolha a aparência usada neste navegador. Vale só para você." },

  // As duas planilhas são de módulos vendidos à parte (ADR-0102): sem nenhum
  // deles a aba some; com um só, a aba mostra só a planilha dele.
  { grupo: "Dados", path: "planilhas", label: "Planilhas", icone: ICONS.planilhas,
    gate: { modulosAny: [MODULO_PLANILHA_LEGADO, MODULO_PROJETOS_EXECUTIVOS] },
    titulo: "Planilhas", desc: "Fontes de dados conectadas ao PharuERP." },
  // Os painéis exportáveis são todos telas da planilha do Gerenciador.
  { grupo: "Dados", path: "exportacao", label: "Exportação auto", icone: ICONS.exportacao,
    gate: { modulosAny: [MODULO_PLANILHA_LEGADO] },
    titulo: "Exportação automática", desc: "Exporta automaticamente para uma pasta do Windows enquanto o app está aberto." },
  { grupo: "Dados", path: "importacoes", label: "Importações", icone: ICONS.importacoes,
    gate: { anyOf: ["importacao:executar", "importacao:view_historico"] },
    titulo: "Importações", desc: "Upload de planilhas externas para o PharuERP — dry-run obrigatório antes de aplicar." },

  // Calendário único da unidade: todos veem (as contas de dias úteis dependem
  // dele); só quem tem `calendario:editar` muda — o backend decide.
  { grupo: "Sistema", path: "calendario", label: "Calendário", icone: ICONS.calendario, gate: null,
    titulo: "Calendário", desc: "Feriados, recessos e pontos facultativos da unidade." },
  // Logo da unidade (folhas de apontamento). Todos veem; só quem tem
  // `unidade:editar_logo` troca — o backend decide.
  // Jornada padrão da unidade e categorias iniciais da agenda (ADR-0090).
  { grupo: "Sistema", path: "agenda", label: "Agenda", icone: ICONS.agenda, gate: { allOf: ["agenda:configurar"] },
    titulo: "Agenda", desc: "Jornada padrão da unidade e as categorias que cada pessoa recebe ao abrir a agenda." },
  { grupo: "Sistema", path: "empresa", label: "Minha empresa", icone: ICONS.unidade, gate: null,
    titulo: "Minha empresa", desc: "Dados da empresa, logo, locais e o que falta configurar." },
  { grupo: "Sistema", path: "integracoes", label: "Integrações", icone: ICONS.integracoes, gate: { anyOf: ["empresa:configurar"] },
    titulo: "Integrações", desc: "Conecte gateways de cobrança, fiscal, banking, CAD e e-mail." },
  { grupo: "Sistema", path: "integracoes-cad", label: "Integrações CAD", icone: ICONS.cad,
    gate: { allOf: ["integracao_cad:view"] },
    titulo: "Integrações CAD", desc: "Credenciais de sistemas CAD/3D externos (DinaBox, etc)." },
  // M-TRA-2: a aba era master-only, então conceder `auditoria:view` não
  // dava acesso a nada — o contador continuava dependendo de um Master
  // abrir a tela para ele. Quem tem só a permissão de auditoria entra
  // aqui e vê apenas a sub-rota de Auditoria (o shell filtra as demais).
  { grupo: "Sistema", path: "acessos", label: "Acessos & RBAC", icone: ICONS.acessos,
    gate: { anyOf: PERMS_ENTRAR_ACESSOS }, splat: true,
    titulo: "Acessos & RBAC", desc: "Gestão completa de usuários, cargos, auditoria e segregação de deveres." },
];

/** Resolve se uma aba e' visivel para o usuario, dado os helpers do AuthContext. */
export function abaPermitida(gate, { isMaster, hasAllPermissions, hasAnyPermission, temModulo }) {
  if (!gate) return true;
  // Contrato antes de permissão: sem o módulo, nem Master vê (ADR-0102).
  if (gate.modulosAny && !gate.modulosAny.some((m) => temModulo?.(m))) return false;
  if (gate.master) return Boolean(isMaster);
  if (gate.allOf) return hasAllPermissions(gate.allOf);
  if (gate.anyOf) return hasAnyPermission(gate.anyOf);
  return true;
}
